import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Single helper for composing Tailwind class names. Resolves conflicts
 * (e.g., `px-2 px-4` -> `px-4`) and handles conditionals.
 *
 * @example
 *   <button className={cn('bg-primary', isDanger && 'bg-danger')} />
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
